import assign from 'object-assign';
import React, { Component } from 'react';
import { Container } from 'flux/utils';

// import { dispatch } from '../../dispatcher/Dispatcher';
// import { getItem as getLang } from '../../common/lang';
import ajax, { ajaxDispatch } from '../../common/utils/ajax';

// import UserDataUtils from '../../data-utils/UserDataUtils';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';

export default class Test extends Component {

  constructor(props) {
    super(props);
    // ajax.get('http://101.230.3.2:8088/ess-calc-exce-timeclock?peroid=')
    //     .then((res) => {
    //         console.log(res);
    //     });

    RepairClockInDataUtils.getEmpRciPeriodList('');
  }

  componentDidMount() {
  
  }

  componentDidUpdate() {
 
  }

  render() {
    return (
      <div >
        <h3>hello world!</h3>
      </div>

    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Tests/TestContainer.jsx